import { createContext, useContext } from 'react';

export const JobContext = createContext(null);

export function useJobContext() {
  return useContext(JobContext);
}
